package com.shadowings.gero.util

actual fun isCalendarIntegrationSupported(): Boolean = false
